$(function() {
	'use strict';

	// Close mobile menu when clicking on a link
	$('.navbar-nav>li>a').not('.smooth-scroll').on('click', function() {
		if ($(window).width() < 1200) {
			$('.navbar-collapse').collapse('hide');
		}
	});

	// Wait for the sticky menu to collapse before calculating the section position.
	$('a.smooth-scroll').on('click', function(event) {
		var target = document.querySelector(this.getAttribute('href'));
		if (!target) {
			return;
		}
		event.preventDefault();
		var scrollToTarget = function() {
			var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
		};
		var menu = $('.navbar-collapse');
		if (menu.hasClass('show') || menu.hasClass('collapsing')) {
			menu.one('hidden.bs.collapse', scrollToTarget);
			if (menu.hasClass('collapsing') && $('.navbar-toggler').attr('aria-expanded') === 'true') {
				menu.one('shown.bs.collapse', function() {
					menu.collapse('hide');
				});
			} else {
				menu.collapse('hide');
			}
		} else {
			scrollToTarget();
		}
	});

});
